<template>
  <loader v-if="dataLoading" />
  <!-- {{ data.stats }} -->
  
  <div class="page">
    <h4>Elenco Moduli RID</h4>
    <!-- <prime-button
    icon="pi pi-pencil" 
    class="p-button-rounded p-button-danger mr-2 mb-2" 
    @click="selectModuloRid()" 
    /> -->
    <div v-if="selectedModuli.length > 0" class="p-d-flex p-p-3 card">
      <prime-button label="Elimina Moduli selezionati" icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2" @click="deleteSelectedModuli()" />
    </div>



    <DataTable :value="data.stats" responsiveLayout="scroll"
      v-model:selection="selectedModuli"
      dataKey=""
>
      <!-- <div v-if="this.is_selected"> -->
        <column selectionMode="multiple" headerStyle="width: 3em">
        </column>
      <!-- </div> -->

      <column field="indice" header="Indice">
      </column>
      <column field="cliente" header="Nome cliente">
      </column>
      <column field="firmatario" header="Firmatario">
      </column>
      <column field="data_creazione" header="data di creazione">
      </column>

      <column>
        <template #body="{data}">
          <prime-button 
          icon="pi pi-user-edit" 
          class="p-button-rounded p-button-info mr-2" 
          @click="signModuloRid(data.indice)" 
          />
        </template>
      </column>
      <column>
        <template #body="{data}">
          <prime-button 
          icon="pi pi-trash" 
          class="p-button-rounded p-button-danger mr-2" 
          @click="deleteModuloRid(data.indice)" 
          />
        </template>
      </column>


      <column>
        <template #body="{data}">
          <prime-button 
          icon="pi pi-eye" 
          class="p-button-rounded p-button-success mr-2" 
          @click="visualizzaPDF(data.url)" 
          />
          <!-- <iframe v-if="mostraPDF" :src="urlPDF" width="100%" height="500px"></iframe> -->
        </template>
      </column>
      <template #empty>
        <div class="text-center">Nessun dato trovato.</div>
      </template> 




      <!-- <column field="start_date" header="Modulo">
        <template #body="{data}">
          {{ (data.start_date !== null) ? moment(data.start_date).locale('it').format('MMMM YYYY').toUpperCase(): '' }}
        </template>
      </column>

      <column field="importo" header="Importo Bollo">
        <template #body="{data}">
          {{currencyFormatter.format( data.importo)}}
        </template>
        
      </column>
      <column :exportable="false">
        <template #body="{data}">
          <prime-button 
          icon="pi pi-search" 
          class="p-button-rounded p-button-info mr-2" 
          @click="ViewReport(data)" 
          />
          
        </template>
      </column> -->
      
    </DataTable>
  </div>
  <!-- <Dialog header="Riepilogo Fatture" v-model:visible="showDialog" modal maximizable :style="{width: '50vw'}">
    <div class="container">
      <p> Mese: <strong>{{moment(dataToShow.start_date).locale('it').format('MMMM YYYY').toUpperCase()}}</strong></p>
      <p> Importo Bollo: <strong>{{currencyFormatter.format(dataToShow.importo)}}</strong></p>
    </div>
    <DataTable :value="dataToShow.fatture" responsiveLayout="scroll">
      <column field="index" header="Indice">
      </column>
      
      <column field="numero_fattura" header="Numero Fattura">
      </column>
      <column field="totale_fattura" header="Importo Fattura">
        <template #body="{data}">
          {{currencyFormatter.format( data.totale_fattura)}}
        </template>
        
      </column>
    </DataTable>
  </Dialog> -->
  </template>
  <script>
  import moment from 'moment'
  
  import Service from '@/services/ask-management/modulo-rid-contratti-vendita-service'
  
  import Loader from '@/components/Loader.vue'
  import PrimeButton from 'primevue/button'
  // import Dialog from 'primevue/dialog';
    export default { 
    components: {
      Loader,
      PrimeButton,
      // Dialog
    },
  
    data() {
      return {
        moment,
        showDialog: false,
        mostraPDF: false,
        urlPDF: '',
        selectedModuli: [],
        is_selected: false,
        // currencyFormatter: new Intl.NumberFormat('it-IT', {
        //   style: 'currency',
        //   currency: 'EUR',
        // }),
  
        dataLoading: false,
        // filter: new Date().getFullYear(),
  
        data: {
          stats: []
        },
      }
    },
  
    created(){
      this.service = new Service(this.$http, this.$eventBus)
      this.getElencoModuliRid()
    },
  
    methods:{
      visualizzaPDF(url) {
        this.service.visualizzaPDF(url)
        .then((res)=> {
          const path = URL.createObjectURL(res.items);
          window.open(path);
        })
        .catch(error => {
          console.error('Errore nella richiesta POST', error);
        });
      },

      selectModuloRid(){
        this.is_selected = !this.is_selected
        if (this.is_selected == false) {
          this.selectedModuli = [];
        }
      },

      deleteSelectedModuli(){
        let selected
        selected = this.selectedModuli.map(this.takeId);
        this.deleteModuloRid(selected)
        // selected.forEach()
        this.selectedModuli = []
      },

      takeId(array){
          return array['indice']
      },

      signModuloRid(id){
        this.dataLoading = true  

        this.service.signModuloRid(id)
        .then(()=> {
          this.getElencoModuliRid()
        })
        .catch(() => {
          console.error();
        })
        .finally(()=> {
          this.dataLoading = false
        })
      },

      deleteModuloRid(id){
        this.dataLoading = true  

        this.service.deleteModuloRid(id)
        .then(()=> {
          this.getElencoModuliRid()
        })
        .catch(() => {
          console.error();
        })
        .finally(()=> {
          this.dataLoading = false
        })
      },

  
      getElencoModuliRid(){
        this.dataLoading = true  
        this.service.getElencoModuliRid()
        .then((res) => {
          this.data.stats = res;
          this.urlPDF = this.data.stats.url;
        })
        .catch(() => {
          console.error();
        })
        .finally(() =>{
          this.dataLoading = false
        })
      }
  
    },
  
    computed:{
      
    },
  
    watch: {
      // filter(newVal) {
      //   this.applyFilter(newVal)
      // },
    },
  }
  </script>
  
  <style scoped>
  .box-center{
    text-align: center;
    font-size: 24px;
  }
  .bold{
    font-weight:bold;
  }

  .container{
    display: flex;
    justify-content: space-around;
  }
  </style>
  